const GennomeInform=[
  {
    "Genome":"NLU",
    "Genome size(bp)":"838457245",
    "Assembly level":"Chromosome"
  },
  {
    "Genome":"American_Lotus_2022",
    "Genome size(bp)":"782491714",
    "Assembly level":"Chromosome"
  },
  {
    "Genome":"NNU",
    "Genome size(bp)":"815220684",
    "Assembly level":"Chromosome"
  },
 
]
let GenomeInformColums=[]
Object.keys(GennomeInform[0]).forEach(key => {
  GenomeInformColums.push({
    title:key,
    key:key,
    align:"center",
    dataIndex:key
  })
})
export {GennomeInform,GenomeInformColums}